import styled from "styled-components";

export const WIZARD_ANIMATION_TIME = 500;
export const WIZARD_ANIMATION_DELAY = 100;
const WIZARD_ANIMATION_GENERAL_DELAY = 500;

export const StyledWizardAnimationItem = styled.div<{ delay?: number }>`
    opacity: 0;
    transform: translateY(30px);
    animation: wizard-animation-item ${WIZARD_ANIMATION_TIME}ms forwards ${({ delay }) => `${(delay || 0) + WIZARD_ANIMATION_GENERAL_DELAY}ms`};
`;
export const StyledWizardAnimationWrapper = styled.div`
    @keyframes wizard-animation-item {
        to {
            opacity: 1;
            transform: translateY(0px);
        }
    }
`;

